import React, { ChangeEvent, Component } from 'react';
import { connect } from 'react-redux';

import scrollToComponent from 'utils/scrollToComponent';
import { categoryHasVisibleItems } from 'components/utils';
import Loading from 'components/Loading';
import getMyselfCategories from 'selectors/myself/getMyselfCategories';

import QualityGroup from './components/QualityGroup';
import MyselfComponent from './MyselfComponent';
import { ICategory } from 'types/possessions';
import { IAppState } from 'types/app';

type Props = { dispatch: Function } & ReturnType<typeof mapStateToProps>;

interface State {
  activeItem: number | null,
  filterString: string,
}

class MyselfContainer extends Component<Props, State> {
  static displayName = 'MyselfContainer';

  state = {
    activeItem: null,
    filterString: '',
  };

  filterItems = (evt: ChangeEvent<HTMLInputElement>) => {
    this.setState({ filterString: evt.currentTarget.value });
  };

  /**
   * Goto Item
   * @param  {Object} item
   * @param  {Object} options
   * @return {undefined}
   */
  gotoItem = (item: { id: number, name: string }, options: any) => {
    const { dispatch } = this.props;
    const {
      id,
      name,
    } = item;

    this.setState({ activeItem: id });

    scrollToComponent(
      document.querySelector(`[data-group-name="${name}"]`),
      { align: 'top', duration: 1500, ...options },
      dispatch,
    );
  };

  trackPosition = (id: number) => {
    const { scrolling } = this.props;
    if (!scrolling) {
      this.setState({ activeItem: id });
    }
  };

  /**
   * Render
   * @return {Object}
   */
  render() {
    const {
      categories,
      descriptiveText,
      name,
      qualities,
    } = this.props;
    const { activeItem, filterString } = this.state;

    // If we have no name, we don't have the character info we need to
    // build the page, so let's wait
    if (!name) {
      return (
        <div style={{ textAlign: 'center' }}>
          <Loading />
        </div>
      );
    }

    const qualityGroups = categories.map((category: ICategory) => (
      <QualityGroup
        onEnterWaypoint={this.trackPosition}
        key={category.id}
        filterString={filterString}
        id={category.id}
        name={category.name}
      />
    ));

    const stickyMenuItems = categories
      .filter((category: ICategory) => category.name) // No nameless categories
      .filter(categoryHasVisibleItems({ filterString, qualities }));

    return (
      <MyselfComponent
        activeItem={activeItem}
        categories={categories}
        descriptiveText={descriptiveText}
        filterString={filterString}
        onFilterStringChange={this.filterItems}
        onGoToItem={this.gotoItem}
        qualityGroups={qualityGroups}
        stickyMenuItems={stickyMenuItems}
      />
    );
  }
}

/*
MyselfContainer.propTypes = {
  categories: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  descriptiveText: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  name: PropTypes.string,
  qualities: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  scrolling: PropTypes.bool.isRequired,
};

MyselfContainer.defaultProps = {
  descriptiveText: undefined,
  name: undefined,
};
 */

const mapStateToProps = (state: IAppState, props: {}) => {
  const {
    myself: {
      qualities,
      character: {
        descriptiveText,
        name,
      },
    },
    scrollToComponent: { scrolling },
  } = state;
  return {
    name,
    qualities,
    scrolling,
    descriptiveText: descriptiveText ?? '',
    categories: getMyselfCategories(state, props),
  };
};

export default connect(mapStateToProps)(MyselfContainer);